import { BookOutlined } from "@ant-design/icons";

const TutorialHeader = () => {
  return (
    <h2 className="header-section-title">
      <BookOutlined rev={undefined} />
      <span style={{ marginLeft: "5px" }}>Tutorial</span>
    </h2>
  );
};

export default TutorialHeader;
